module.exports = __webpack_public_path__ + "img/featured.62c5bb9e.jpg";